import type { File } from '@actual-app/core/types/file';

/** Identificador estable del presupuesto (en la nube o en el dispositivo). */
export function claveArchivo(file: File): string {
  return 'cloudFileId' in file && file.cloudFileId
    ? file.cloudFileId
    : 'id' in file
      ? file.id
      : file.name;
}

type Acceso = {
  userId: string;
  userName: string;
  displayName?: string | null;
  owner: boolean;
};

function accesos(file: File): Acceso[] {
  return 'usersWithAccess' in file ? (file.usersWithAccess ?? []) : [];
}

/** Nombres de las otras personas con acceso (sin ti ni el usuario servidor). */
export function compartidoCon(file: File, currentUserId: string): string[] {
  return accesos(file)
    .filter(u => u.userName !== '' && u.userId !== currentUserId)
    .map(u => u.displayName || u.userName);
}

/**
 * El dueño es el usuario anónimo del servidor (presupuestos de antes de entrar
 * con Google): sale como «Server» y conviene pasarlo a una cuenta.
 */
export function duenoEsServidor(file: File): boolean {
  const dueno = accesos(file).find(u => u.owner);
  return dueno?.userName === '';
}

/** Nombre del dueño si no eres tú (y no es el usuario servidor). */
export function nombreDueno(file: File, currentUserId: string): string | null {
  const dueno = accesos(file).find(u => u.owner);
  if (!dueno || dueno.userId === currentUserId || dueno.userName === '') {
    return null;
  }
  return dueno.displayName || dueno.userName;
}
